var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiLink from '@material-ui/core/Link';
/**
 * Kareo wrapped component of the Material-UI Link. The prop API has been limited to props defined in LinkProps.
 *
 * The Link component allows you to easily customize anchor elements with your theme colors and typography styles.
 *
 * Material-UI Link: [Docs](https://v4.mui.com/components/links/), [API](https://v4.mui.com/api/link/)
 *
 * @storybook: [Link](http://design.kareoprod.ent/design-system/?path=/story/components-data-display--link)
 */
var Link = React.forwardRef(function (props, ref) {
    // For security, default rel to 'noopener' if target is '_blank'.
    // See recommendation in Material UI documentation:
    // https://mui.com/material-ui/react-link/#security
    var secureProps;
    if (props.target === '_blank') {
        secureProps = __assign({ rel: 'noopener' }, props);
    }
    else {
        secureProps = props;
    }
    return React.createElement(MuiLink, __assign({}, secureProps, { ref: ref }));
});
Link.displayName = 'KareoLink';
export default Link;
